import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import type { ReactElement } from 'react';

import HtmlContent from '@/components/HtmlContent';
import Layout from '@/components/Landing/Layout';
import Text from '@/components/Text';
import { getResponsibleDisclosure } from '@/services/strapi/responsible-disclosure';
import { documentDateFormatter } from '@/utils/documentDateFormatter';

const responsibleDisclosurePage = ({
  policy,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { title, lastUpdated, content } = policy.data;

  return (
    <div className="mt-28 flex w-full flex-col items-center justify-center gap-10 p-2 md:p-5">
      <div className="flex w-full max-w-6xl flex-col items-center justify-start">
        <div className="mb-4 mt-2 flex w-full flex-col ">
          <Text variant="h1">{title}</Text>
        </div>
        <Text className="mb-4 mt-2 flex w-full flex-col font-semibold text-neutral-100">
          Last updated: {documentDateFormatter(lastUpdated)}
        </Text>
        <HtmlContent content={content} variant="cmsContent" />
      </div>
    </div>
  );
};

export default responsibleDisclosurePage;

export const getStaticProps: GetStaticProps = async () => {
  try {
    const responsibleDisclosure = await getResponsibleDisclosure();

    return {
      props: { policy: responsibleDisclosure },
      revalidate: 10,
    };
  } catch (error) {
    return { notFound: true };
  }
};

responsibleDisclosurePage.getLayout = (page: ReactElement) => (
  <Layout>{page}</Layout>
);
